/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type app_v1_external_assets_UpdateExternalAssetTrade = {
    acquisition_date?: string | null;
    correlation_proxy?: string | null;
    cost_basis?: number | null;
    estimated_tax_percent?: number | null;
    expected_return?: number | null;
    interest_rate?: number | null;
    liquidity?: app_v1_external_assets_UpdateExternalAssetTrade.liquidity | null;
    name?: string | null;
    notes?: string | null;
    ownership_share_percent?: number | null;
    price_per_unit?: number | null;
    properties?: Record<string, any> | null;
    quantity?: number | null;
    symbol?: string | null;
    total_value?: number | null;
    valuation_date?: string | null;
    volatility?: number | null;
};

export namespace app_v1_external_assets_UpdateExternalAssetTrade {

    export enum liquidity {
        HIGH = 'high',
        MEDIUM = 'medium',
        LOW = 'low',
        ILLIQUID = 'illiquid',
    }


}

